import { HeartIcon } from 'lucide-preact';
import { useDispatch } from 'react-redux';

import LockBadge from '@/components/LockBadge';
import { setMembersOnlyWarningModalState } from '@/components/MembersOnlyWarningModal/redux/actions';
import { cn } from '@/lib/utils';

import useToggleMediaLike from './useToggleMediaLike';

const LikeButton = ({ data, onClick = () => {}, mediaId, type, noCount, className }) => {
  const dispatch = useDispatch();
  const { logged, isLiked, likes, toggle } = useToggleMediaLike({
    mediaId,
    type,
    isLiked: data.isLiked,
    likes: data.likes,
  });

  const likeContent = () => {
    if (!logged) {
      dispatch(setMembersOnlyWarningModalState({ type: 'guest-general' }));
      return;
    }

    onClick();
    toggle();
  };

  return (
    <button
      type="button"
      onClick={likeContent}
      className={cn('preflight preflight-button relative flex items-center justify-center', className)}
    >
      <HeartIcon className={cn('size-[1em]', isLiked && 'fill-current text-system-pink')} />
      {!noCount && (
        <span className="pointer-events-none absolute inset-0 flex items-center justify-center text-white">
          {likes < 1000 ? likes : `${(likes / 1000).toFixed(1)}k`}
        </span>
      )}
      {!logged && <LockBadge />}
    </button>
  );
};

export default LikeButton;
